import React, { useEffect, useState } from "react";
import "./SearchBarStyles.css";
import { Loader, TagInput, TagPicker } from "rsuite";
import usePost from "../../../customhooks/UsePost";
// import SpinnerIcon from "@rsuite/icons/legacy/Spinner";
import { Trans, useTranslation } from "react-i18next";
import { useLoaderData } from "react-router-dom";
// import { t } from "i18next";

export default function SearchKey({ values, setValues, SearchBodyData }) {
  const [suggestions, setSuggestions] = React.useState([]);
  const { t } = useTranslation();
  let loaderDetails = useLoaderData();
  const {
    post: getJobs,
    isLoading: loading,
    data,
    error,
  } = usePost("/jobsearch/autosuggestions");
  const [words, setWords] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // console.log(words);
  
  const fetchdata = (word) => {
    setIsLoading(true);
    setWords(word);

    let body = {
      searchkey: word ?? "",
      companyID: loaderDetails?.companyID,
    };

    getJobs(body).then((res) => {
    const seenLabels = new Set();
    const uniqueByLabel = res?.data?.result?.filter(item => {
        if (seenLabels.has(item?.label)) {
            return false;
        }
        seenLabels.add(item?.label);
        return true;
    });
      const updatedSuggestions = uniqueByLabel?.map(
        (suggestions, index) => ({
          label: suggestions?.label,
          key: index,
          value: suggestions?.label,
          match_type: suggestions?.match_type,
        })
      );
      // const UpdateDate = res?.data?.result?.map((x) => {
      //   return { label: x, value: x };
      // });
        setIsLoading(false);
        setSuggestions(updatedSuggestions);
      // console.log(res?.data?.result);
    }).catch((err)=>{
      setIsLoading(false);
      console.log("Error in Get Auto Suggestions..!")
    });
  };
  const [cacheData, setCacheData] = React.useState([]);

  const handleSelect = (value, item, event) => {
    setCacheData([...cacheData, item]);
  };
  // console.log(SearchBodyData);
  useEffect(() => {
    const UpdateDate = SearchBodyData?.searchKey?.map((x) => {
      return { label: x, value: x };
    });
    setSuggestions(UpdateDate);
    // const updatedValues = Array.isArray(values) ? values : [];
    // setValues(UpdateDate);
  }, [SearchBodyData]);

  const handleChange = (newValues) => {
    let updatedValues;
    if (Array.isArray(newValues)) {
      updatedValues = newValues;
    } else if (newValues) {
      updatedValues = [newValues];
    } else {
      updatedValues = [];
    }
    setValues(updatedValues);
  };
  return (
    <div className="search-bar-container">
      <TagPicker
        creatable={suggestions?.length <= 0}
        className="width no-border d-block"
        onCreate={(value, item) => {
          // console.log(value, item);
        }}
        searchBy={() => true}
        data={suggestions ?? []}
        cacheData={cacheData}
        value={values}
        labelKey="label"
        valueKey="value"
        onChange={handleChange}
        onSearch={fetchdata}
        onSelect={handleSelect}
        block
        //  placeholder="Enter skill, designations, keywords"
        placeholder={t("enterSkills,Designations,Keywords", {
          defaultValue: "Enter Skills, Designations,  Keywords",
        })}
        //  placeholder={t("enter", { defaultValue: "Enter" }) + t("skill", { defaultValue: "Skill" }) +
        //               t("designations", { defaultValue: "designations" }) + t("keywords", { defaultValue: "Keywords" })}
        renderMenuItem={(item, values) => {
          return (
            <div className="w-100">
              {isLoading ? (
                <p style={{ padding: 4, color: "#999", textAlign: "center" }}>
                  <Loader /> Loading...
                </p>
              ) : (
                <>
                  {values?.match_type == "skills" && (
                    <div className="d-flex justify-content-between textOverFlow">
                      <span className="mx-1 textOverFlow campagnLabel">
                        {item}
                      </span>
                      <span className="ProfileTitle">
                        <Trans i18nKey="skills" defaults="Skills" />
                      </span>
                    </div>
                  )}
                  {values?.match_type == "job_titles" && (
                    <div className="d-flex justify-content-between textOverFlow">
                      <span className="textOverFlow campagnLabel">{item}</span>
                      <span
                        className="ProfileTitle"
                        style={{ marginLeft: "-5px" }}
                      >
                        <Trans i18nKey="jobTitle" defaults="Job Title" />
                      </span>
                    </div>
                  )}
                  {suggestions?.length == 0 && (
                    <span className="textOverFlow campagnLabel">{item}</span>
                  )}
                </>
              )}
            </div>
          );
        }}
      />
    </div>
  );
}
